var css = {"video_container":"BelongExplainerVideo-module_video_container__My9iH"};

export { css as default };
